import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ApplyForm from "./ApplyForm";

const UiUxDesigner: React.FC = () => {
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Career details" pagesub=" UI/UX Designer" />
                        <section className="career-details">
                            <div className="container">
                                <div className="cp-details-wrap">

                                    {/* Manager Info */}
                                    <div className="cp-manager_info">
                                        <h2 className="details-content-title mb-30">
                                            UI/UX Designer – (Full-time)
                                        </h2>

                                        <ul className="xb-details-content list-unstyled mb-35">
                                            <li><span>Department :</span> Product Design & User Experience</li>
                                            <li><span>No. of Openings :</span> (3)</li>
                                            <li><span>Job Type :</span> Full-Time</li>
                                            <li><span>Location :</span> Software Technology Park Chattogram, Level 6, Agrabad Circle, Chittagong, Bangladesh</li>
                                            <li><span>Working days : </span>6 days.</li>
                                            <li><span>Salary Range : </span>Negotiable.</li>
                                            <li><span>Experience Required :</span> 0–4 Year (Fresh Graduates Encouraged)</li>
                                        </ul>

                                        <p className="mb-30">
                                         We’re looking for a talented and user-centric UI/UX Designer to join our product and design team. You will be responsible for creating intuitive interfaces, seamless user journeys, and visually appealing designs across web and mobile platforms. You should be passionate about problem-solving, user behavior, and modern design standards.
                                        </p>

                                        <p>
                                          A deep understanding of UX principles, interaction design, and prototyping tools is essential. You will collaborate with product managers, developers, and other designers to deliver meaningful digital experiences.
                                        </p>
                                    </div>

                                    {/* What you'll do */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">What you'll get to do...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Conduct user research, interviews, and competitor analysis.</li>
                                            <li>Create user flows, wireframes, prototypes, and high-fidelity UI designs.</li>
                                            <li>Design responsive interfaces for web and mobile applications.</li>
                                            <li>Collaborate closely with product managers and engineering teams.</li>
                                            <li>Translate business requirements into smooth user experiences.</li>
                                            <li>Develop design systems, components, and style guides.</li>
                                            <li>Test and refine designs based on feedback and usability studies.</li>
                                            <li>Ensure consistency across all digital touchpoints.</li>
                                            <li>Participate in brainstorming sessions and contribute creative ideas.</li>
                                        </ul>
                                    </div>

                                    {/* Experience section */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Your experience should include...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Strong proficiency with Figma, Adobe XD, or Sketch.</li>
                                            <li>Solid understanding of UX research, information architecture, and interaction design.</li>
                                            <li>Strong UI skills with excellent attention to detail, spacing, and typography.</li>
                                            <li>Experience creating wireframes, prototypes, and design systems.</li>
                                            <li>Ability to work cross-functionally and communicate design decisions clearly.</li>
                                            <li>Experience designing responsive layouts and mobile-first interfaces.</li>
                                            <li>A strong portfolio showcasing real UI/UX work and case studies.</li>
                                        </ul>
                                    </div>

                                    {/* You might have */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">You might also have...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Experience with usability testing and heuristic evaluation.</li>
                                            <li>Knowledge of motion design or micro-interactions.</li>
                                            <li>Understanding of front-end basics (HTML/CSS/React – not mandatory).</li>
                                            <li>Experience working in agile product teams.</li>
                                            <li>Knowledge of accessibility standards and inclusive design.</li>
                                            <li>Ability to design dashboards, SaaS interfaces, and complex workflows.</li>
                                            <li>Passion for product thinking and continuous improvement.</li>
                                        </ul>
                                    </div>

                                    {/* Benefits */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Great benefits...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Competitive monthly salary with performance reviews.</li>
                                            <li>Opportunity to work on high-scale, real-world applications.</li>
                                            <li>Friendly and collaborative work environment.</li>
                                            <li>Access to learning materials and training sessions.</li>
                                            <li>Flexible working hours.</li>
                                        </ul>
                                    </div>
                                    
                                    {/* ApplyForm */}
                                    <ApplyForm />

                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default UiUxDesigner;
